import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./join.css";
const Join = () => {
  const [name, setName] = useState("");
  const [room, setRoom] = useState("");
  return (
    <div className="joinOuterContainer">
      <div className="joinInnerContainer">
        <h1 className="heading">Join</h1>
        <div>
          <input
            placeholder="Name"
            className="joinInput"
            type="text"
            onChange={(event) => {
              setName(event.target.value);
            }}
          ></input>
        </div>
        <div>
          <input
            placeholder="Room"
            className="joinInput mt-20"
            type="text"
            onChange={(event) => {
              setRoom(event.target.value);
            }}
          ></input>
        </div>
        {/* search query with room & name as params */}
        <Link
          onClick={(event) => (!name || !room ? event.preventDefault() : null)}
          to={`/chat?name=${name}&room=${room}`}
        >
          {/* using onclick from breaking the app when no name or roomis mentioned */}
          <button className="button mt-20" type="submit">
            SignIn
          </button>
        </Link>
      </div>
    </div>
  );
};
export default Join;
